/* ---- scroll reveal + product gallery (router removed: real Shopify pages now) ---- */
(function(){
  function flush(){
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
      if(el.getBoundingClientRect().top < window.innerHeight*1.05) el.classList.add('in');
    });
  }
  window.addEventListener('scroll', flush, {passive:true});
  window.addEventListener('resize', flush);
  flush(); setTimeout(flush,60);

  var main=document.getElementById('galMain');
  if(main){
    document.querySelectorAll('.thumb').forEach(function(t){
      t.addEventListener('click',function(){
        document.querySelectorAll('.thumb').forEach(function(x){x.setAttribute('aria-selected','false')});
        t.setAttribute('aria-selected','true');
        main.style.opacity=0;
        setTimeout(function(){
          main.className='gal-main-img '+t.dataset.img+(t.dataset.cover==='1'?' cover':'');
          main.style.padding=t.dataset.cover==='1'?'0':'14px';
          main.style.opacity=1;
        },160);
      });
    });
  }
})();

/* ---- merch product page: gallery + variant picker ---- */
(function(){
  var main = document.getElementById('pmMainImg');
  document.querySelectorAll('.pm-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(!main) return;
      document.querySelectorAll('.pm-thumb').forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
      main.style.opacity = 0;
      setTimeout(function(){ main.src = t.dataset.src; main.style.opacity = 1; }, 140);
    });
  });

  var variants = document.getElementById('pm-variants');
  var selects  = document.querySelectorAll('.pm-select');
  var priceEl  = document.querySelector('.pm-price .price');
  var addBtn   = document.querySelector('.pm-add');
  if(!variants || !selects.length) return;

  /* when a product has many colours, show only that colour's photos */
  function filterGallery(){
    var thumbs = document.querySelectorAll('.pm-thumb[data-colour]');
    if(!thumbs.length) return;

    var colour = '';
    selects.forEach(function(s){
      var lbl = (s.previousElementSibling && s.previousElementSibling.textContent || '').toLowerCase();
      if(lbl.indexOf('colour') !== -1 || lbl.indexOf('color') !== -1) colour = s.value;
    });
    if(!colour) return;

    var firstShown = null, shown = 0;
    thumbs.forEach(function(t){
      var hit = t.dataset.colour === colour;
      t.hidden = !hit;
      if(hit){ shown++; if(!firstShown) firstShown = t; }
    });
    if(!shown){ thumbs.forEach(function(t){ t.hidden = false; }); return; }

    if(main && firstShown){
      main.src = firstShown.dataset.src;
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      firstShown.classList.add('on');
    }
  }

  function sync(){
    var chosen = [];
    selects.forEach(function(s){ chosen.push(s.value); });
    var want = chosen.join(' / ');
    var found = null;
    Array.prototype.forEach.call(variants.options, function(o){
      if(o.textContent.trim() === want) found = o;
    });
    if(found){
      variants.value = found.value;
      if(priceEl && found.dataset.price) priceEl.textContent = found.dataset.price;
      if(addBtn){
        addBtn.disabled = found.disabled;
        addBtn.textContent = found.disabled ? 'Sold out' : 'Add to cart';
      }
    }
    filterGallery();
  }
  selects.forEach(function(s){ s.addEventListener('change', sync); });
  sync();
})();

/* ---- outbound tracking: bottle is sold on an external merchant ---- */
(function(){
  function send(name, params){
    if (window.gtag)      { window.gtag('event', name, params); }
    if (window.dataLayer) { window.dataLayer.push(Object.assign({event:name}, params)); }
    if (window.fbq)       { window.fbq('trackCustom', name, params); }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.track){
      try { window.ShopifyAnalytics.lib.track(name, params); } catch(e){}
    }
  }

  /* keep the first-touch source for the whole visit */
  try{
    var ss = window.sessionStorage;
    if (ss && !ss.getItem('pg_src')){
      var q = new URLSearchParams(location.search);
      ss.setItem('pg_src', q.get('utm_source') || document.referrer || 'direct');
    }
  }catch(e){}

  document.addEventListener('click', function(ev){
    var a = ev.target.closest && ev.target.closest('a[href^="http"]');
    if(!a) return;
    var host;
    try { host = new URL(a.href).hostname; } catch(e){ return; }
    if (host === location.hostname) return;

    var src = '';
    try { src = window.sessionStorage.getItem('pg_src') || ''; } catch(e){}

    send('outbound_buy_click', {
      merchant: a.dataset.merchant || host,
      link_url: a.href,
      page: location.pathname,
      first_touch: src
    });
  }, true);
})();



/* ---- store locator: list + map, hover highlights the pin ---- */
(function(){
  var listEl = document.getElementById('stList');
  var mapEl  = document.getElementById('stMap');
  if(!listEl) return;

  var cards  = Array.prototype.slice.call(document.querySelectorAll('[data-store]'));
  var groups = Array.prototype.slice.call(document.querySelectorAll('[data-group]'));
  var q      = document.getElementById('stQ');
  var count  = document.getElementById('stCount');
  var empty  = document.getElementById('stEmpty');

  var GOLD = '#D9A94E', HONEY = '#C77D2E', INK = '#14100B';
  var map = null, markers = {}, active = null;

  function label(n){ return n + (n === 1 ? ' location' : ' locations'); }

  function icon(n, on){
    return L.divIcon({
      className: 'st-marker' + (on ? ' on' : ''),
      html: '<span>' + n + '</span>',
      iconSize: on ? [34,34] : [26,26],
      iconAnchor: on ? [17,17] : [13,13]
    });
  }

  function highlight(i, fly){
    if(active === i) return;
    if(active && markers[active]) markers[active].setIcon(icon(active, false));
    active = i;
    var m = markers[i];
    if(!m) return;
    m.setIcon(icon(i, true));
    m.setZIndexOffset(1000);
    if(fly && map) map.panTo(m.getLatLng(), {animate:true, duration:.4});
  }

  function clearHighlight(){
    if(active && markers[active]) markers[active].setIcon(icon(active, false));
    active = null;
  }

  function fit(){
    if(!map) return;
    var pts = cards.filter(function(c){ return !c.hidden; })
                   .map(function(c){ return [ +c.dataset.lat, +c.dataset.lng ]; });
    if(!pts.length) return;
    map.fitBounds(L.latLngBounds(pts), { padding:[40,40], maxZoom: pts.length === 1 ? 14 : 11 });
  }

  function run(){
    var v = q ? q.value.trim().toLowerCase() : '';
    var shown = 0;
    cards.forEach(function(c){
      var hit = !v || (c.dataset.find || '').indexOf(v) !== -1;
      c.hidden = !hit;
      if(markers[c.dataset.i]){
        if(hit) markers[c.dataset.i].addTo(map);
        else    map.removeLayer(markers[c.dataset.i]);
      }
      if(hit) shown++;
    });
    groups.forEach(function(g){
      g.hidden = g.querySelectorAll('[data-store]:not([hidden])').length === 0;
    });
    if(count) count.textContent = label(shown);
    if(empty) empty.hidden = shown !== 0;
    fit();
  }

  function build(){
    if(!mapEl || typeof L === 'undefined') { if(q){ q.addEventListener('input', run); } return; }

    map = L.map(mapEl, { scrollWheelZoom:false, zoomControl:true, attributionControl:true });
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; OpenStreetMap &copy; CARTO',
      maxZoom: 20
    }).addTo(map);

    cards.forEach(function(c){
      var i = c.dataset.i;
      var m = L.marker([ +c.dataset.lat, +c.dataset.lng ], { icon: icon(i, false) }).addTo(map);
      m.bindPopup('<strong>' + c.dataset.brand + ' &middot; ' + c.dataset.name + '</strong><br>' + c.dataset.addr);
      m.on('mouseover', function(){ highlight(i, false); c.classList.add('on'); });
      m.on('mouseout',  function(){ clearHighlight(); c.classList.remove('on'); });
      m.on('click', function(){
        c.scrollIntoView({ block:'nearest', behavior:'smooth' });
        c.classList.add('on');
        setTimeout(function(){ c.classList.remove('on'); }, 1600);
      });
      markers[i] = m;

      c.addEventListener('mouseenter', function(){ highlight(i, true); });
      c.addEventListener('focus',      function(){ highlight(i, true); });
      c.addEventListener('mouseleave', clearHighlight);
      c.addEventListener('blur',       clearHighlight);
      c.addEventListener('click', function(ev){
        if(ev.target.closest('.st-go')) return;
        highlight(i, true);
        if(map) map.setView(m.getLatLng(), 14, {animate:true});
        m.openPopup();
      });
    });

    if(q) q.addEventListener('input', run);
    run();
    setTimeout(function(){ map.invalidateSize(); fit(); }, 250);
  }

  if(typeof L !== 'undefined') build();
  else window.addEventListener('load', build);
})();